import { render } from "./ModalProductAttributes.vue?vue&type=template&id=b874d462&scoped=true"
import script from "./ModalProductAttributes.vue?vue&type=script&lang=js"
export * from "./ModalProductAttributes.vue?vue&type=script&lang=js"

import "./ModalProductAttributes.vue?vue&type=style&index=0&id=b874d462&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b874d462"]])

export default __exports__